module.exports = __webpack_public_path__ + "img/nest.6bbaff77.png";